export { default } from "../private-dining/amenities";